import { Roles } from 'lib/constants/roles';
import { Permission } from 'lib/enum/permission.enum';
import { Role } from 'lib/types/role-type';
import * as R from 'ramda';
import { sortAsc, sortDesc } from './array.utils';

const getLowestRole = (roles: Role[]): Role => {
    const lowestRole = [...roles].sort((a: Role, b: Role) => sortAsc(a.hierarchyRank, b.hierarchyRank)).pop() as Role;
    return lowestRole;
};

const getHighestRole = (roles: Role[]): Role => {
    const lowestRole = [...roles].sort((a: Role, b: Role) => sortDesc(a.hierarchyRank, b.hierarchyRank)).pop() as Role;
    return lowestRole;
};

const getLowestReadingRole = (roles: Role[]): Role => {
    const lowestRole = [...roles]
        .sort((a: Role, b: Role) => sortAsc(a.hierarchyRank, b.hierarchyRank))
        .slice(0, roles.length)
        .pop() as Role;
    return lowestRole;
};

const ROLES_DICT: Record<string, Role> = R.indexBy(R.prop('id'), Roles);

const ROLE_PERMISSIONS_MAP = new Map<string, Set<Permission>>();

Roles.forEach(role => {
    ROLE_PERMISSIONS_MAP.set(role.id, new Set(role.permissions));
});

export { getLowestRole, getHighestRole, getLowestReadingRole, ROLES_DICT, ROLE_PERMISSIONS_MAP };
